import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import DasApi from "../../api/DasApi";
import Spinner from "../../components/Spinner/Spinner";
import { StyledMain } from "../../styled/StyledMain";
import { MainContainer } from "../../styled/StyledMainContainer";
import { DasRedirectStyle } from "./styles/DasRedirectStyles";

import Blank from "./components/blank/Blank";
import LDBX from "./components/ldbx/LDBX";
const COOKIE_NAME = "mobileId";

const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

const DasRedirect = () => {
  const [deviceNotFoundUrl] = useState("/redirect/device-not-found");

  const params = useParams();
  const [searchParams] = useSearchParams();

  const entityCode = searchParams.get("e") || "XXXX";

  const entityComponents: { [key: string]: JSX.Element } = {
    "0000": <Blank />,
    "0001": <LDBX />,
  };

  useEffect(() => {
    async function validate() {
      const serialNumber = searchParams.get("i");

      if (!serialNumber) {
        window.location.replace("https://www.manage-mii.co.uk");
      } else {
        const cryptogram = searchParams.get("c");
        const accountId = searchParams.get("u");

        const mobileId = getCookie(COOKIE_NAME);

        try {
          const checkDasDeviceResponse = await DasApi.dasCheckDevice(
            serialNumber,
            cryptogram || null,
            mobileId || null,
            accountId || null,
          );

          window.location.replace(checkDasDeviceResponse.redirectUrl);
        } catch (e) {
          window.location.replace(deviceNotFoundUrl);
        }
      }
    }
    validate();
  }, [deviceNotFoundUrl, params.serialNumber, searchParams]);

  return (
    <div>
      <StyledMain>
        <MainContainer>
          {entityComponents[entityCode] || (
            <DasRedirectStyle>
              <Spinner />
              <h3>Powered by DIGISEQ</h3>
            </DasRedirectStyle>
          )}
        </MainContainer>
      </StyledMain>
    </div>
  );
};

export default DasRedirect;
